import { styled } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

export const TemplateCardContainer = styled('div')(({ theme }) => ({
  borderRadius: theme.spacing(0),
  borderBottom: `1px solid ${theme.palette.grey[300]}`,
  marginBottom: theme.spacing(2),
  minHeight: theme.spacing(10)
}));

export const TextBoxContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2)
}));

export const TextContainer = styled('div')(({ theme }) => ({
  padding: theme.spacing(1)
}));

export const ActionsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: theme.spacing(1),
  margin: theme.spacing(1, 0)
}));

export const StyledIcon = styled('span')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  color: theme.palette.grey[600]
}));

export const TemplateTypography = styled(Typography)({
  whiteSpace: 'pre-line'
});

export const FlexRowBetween = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
});
